"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentCategory = exports.getSubcategoriesForLeftColumn = exports.getSubcategories = void 0;
var _searchTree = _interopRequireDefault(require("../searchTree"));
var filterSubcategory = function filterSubcategory(subcategories) {
  var _subcategories$filter;
  return (_subcategories$filter = subcategories.filter(function (el) {
    return el != null && Object.keys(el).length > 0;
  })) === null || _subcategories$filter === void 0 ? void 0 : _subcategories$filter[0];
};
var getSubcategories = function getSubcategories(categories, currentCategory, getRoute, router) {
  var _filterSubcategory;
  return categories && currentCategory && ((_filterSubcategory = filterSubcategory(categories.map(function (category) {
    return (0, _searchTree["default"])(category, currentCategory.id);
  }))) === null || _filterSubcategory === void 0 ? void 0 : _filterSubcategory.subcategories.map(function (subcategory) {
    return {
      url: subcategory.url,
      label: subcategory === null || subcategory === void 0 ? void 0 : subcategory.name,
      additionalLabel: false,
      onCategoryClick: function onCategoryClick() {
        return router && getRoute && router.push(getRoute("category-page", subcategory).href, subcategory.url.indexOf("/") === 0 ? subcategory.url : "/" + subcategory.url);
      }
    };
  }));
};
exports.getSubcategories = getSubcategories;
var getSubcategoriesForLeftColumn = function getSubcategoriesForLeftColumn(categories, currentCategory) {
  var _filterSubcategory2;
  return categories && ((_filterSubcategory2 = filterSubcategory(categories.map(function (category) {
    return (0, _searchTree["default"])(category, currentCategory.level > 4 ? currentCategory.parentId : currentCategory.id);
  }))) === null || _filterSubcategory2 === void 0 ? void 0 : _filterSubcategory2.subcategories);
};
exports.getSubcategoriesForLeftColumn = getSubcategoriesForLeftColumn;
var getParentCategory = function getParentCategory(categories, currentCategory) {
  return filterSubcategory(categories.map(function (category) {
    return (0, _searchTree["default"])(category, currentCategory.parentId);
  }));
};
exports.getParentCategory = getParentCategory;